import "./ServiceTextStyles.css";

function ServiceText() {
  return (
    <div className="service-cointainer">
      <h1>Commercial and Offshore Fleets</h1>
      <h2>Crew Selection</h2>
      <p>
        We assist our clients in selecting experienced and professional crew
        members for various types of vessels. Our experienced staff takes all
        necessary steps to select qualified candidates, conduct interviews and
        document verification to ensure that crew members meet the standards and
        requirements of our clients. This includes evaluating the qualifications
        and experience of candidates, checking references, and taking into
        account the specific features and requirements of each vessel and its
        owner when selecting the crew. Our goal is to provide safety and comfort
        to our clients, as well as to ensure efficient vessel operations.
      </p>
      <h2>Agency Work</h2>
      <p>
        It includes a wide range of services aimed at providing comfortable and
        safe navigation of the vessel. We provide services for crew transfer,
        organizing medical services and insurance, as well as ensuring
        communication and interaction with port services of different countries.
        Our team of specialists is ready to provide qualified assistance and
        support around the clock in any situations related to the vessel's stay
        in port.
      </p>
      <h2>Consulting Services</h2>
      <p>
        Consulting services include providing professional assistance and advice
        to our clients on various issues related to shipping and seafaring. Our
        experts provide advice on crew selection, compliance with international
        norms and regulations, as well as other issues related to vessel
        management. We strive to stay up-to-date with the latest changes in
        legislation and regulatory norms so that our clients can be confident in
        the accuracy and relevance of our consultations.
      </p>

      <h1>Passenger Fleet </h1>
      <h2>Crew Selection</h2>
      <p>
        When selecting a crew for passenger and yacht fleets, we have extensive
        experience in providing high-quality services for mega-yachts and
        VIP-class vessels. Our experienced personnel take all necessary steps to
        select qualified candidates, conduct interviews and document
        verification to ensure that crew members meet the standards and
        requirements of our clients. We also consider the specific features and
        requirements of each particular vessel and its owner when selecting crew
        members. Our goal is to ensure the safety and comfort of our clients, as
        well as the efficient operation of the vessel.
      </p>
      <h2>Crew Training</h2>
      <p>
        We provide comprehensive crew training services, including testing for
        technical and professional skills as well as psychological tests to
        determine the suitability of potential candidates for working on a
        vessel. We also provide briefing and training on safety measures and
        environmental responsibility on board the ship.
      </p>
      <h2>Consulting Services</h2>
      <p>
        Our company provides professional consulting services related to the
        management and operation of passenger fleets and yachts. In addition, we
        are ready to provide consulting support to our clients on such important
        issues as on-board safety and compliance with international and local
        norms and regulations. Our goal is to help our clients manage their
        vessels as efficiently as possible and ensure the safety and comfort of
        their passengers.
      </p>
      <h2>Yacht Brokerage Services</h2>
      <p>
        Our company provides a full range of yacht brokerage services, including
        buying and selling yachts. We have a deep knowledge of the yacht market
        and extensive experience working with yachts of various types and sizes.
        Our team of experts will help you find the perfect yacht that meets your
        needs and budget, and conduct all necessary inspections and evaluations
        of the vessel.
      </p>
      <div className="cert-imgs">
        
      </div>
    </div>
  );
}

export default ServiceText;
